module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/snowboarding@3x_01a2e1.jpg";